interface BrandProps {
  subtitle?: string
  /** Hide the subtitle — used where vertical space is tight */
  compact?: boolean
  /**
   * The wordmark as the login page draws it: WONDER heavy, WORKS light.
   *
   * Opt-in rather than everywhere, because the Miro panel's header has 300px
   * to work with and capitals take more room than the same word in mixed case.
   * Both surfaces can have it the day that changes — it is one prop.
   */
  split?: boolean
  /** The words alone, without the mark (the website's top bar, 2026-10-21). */
  noMark?: boolean
}

/**
 * WonderWorks wordmark. The logo PNG lives in public/ so both the
 * website and the Miro panel resolve it from the site root.
 */
export function Brand({ subtitle = 'WovenWorks', compact = false, split = false, noMark = false }: BrandProps) {
  return (
    <span className="ww-brand">
      {/* The ticks and the W as two layers (the same two the chat box and
          the sign-in page use), so a light page can draw the white ticks
          black without touching the W's colours. */}
      {noMark ? null : (
        <span className="ww-brand__mark" role="img" aria-label="WonderWorks">
          <img className="ww-brand__ring" src="/brand/logo-ring.svg" alt="" />
          <img className="ww-brand__w" src="/brand/logo-mark.svg" alt="" />
        </span>
      )}
      <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
        {split ? (
          <span className="ww-brand__name ww-brand__name--split">
            <span className="ww-brand__wonder">WONDER</span>
            <span className="ww-brand__works">WORKS</span>
          </span>
        ) : (
          <span className="ww-brand__name">WonderWorks</span>
        )}
        {!compact && subtitle ? <span className="ww-brand__sub">{subtitle}</span> : null}
      </span>
    </span>
  )
}
